import { effect, Injectable, signal } from '@angular/core';
import { GlobalConfig } from '../models/global-settings';
import { MessageService } from 'primeng/api';


const DEFAULT_GLOBAL_CONFIG: GlobalConfig = {

  globalSettings: {
    msalLogin: true,
    standardLogin: false,
    bootstrap: false,
    tailwind: true,
    collapseMenu: true,
    collapseMenuByDefault: false,
    logoInMenu: true,
    logoOnLogin: true,
    poweredByCCC: true,
  },
  globalTheme: {
    primarySiteColor: '#2A7CB8',
    secondarySiteColor: '#F87E7F',
    tertiarySiteColor: '#5DC7CC',
    logoDarkUrl: 'assets/franklin-dark.png',
    logoLightUrl: 'assets/franklin-light.png',
    logoLightIconUrl: 'assets/franklins-light-icon.png',
    logoCCCUrl: 'assets/ccc-light.webp',
  },
}

@Injectable({
  providedIn: 'root',
})


export class GlobalSettingsService {


  private readonly _globalConfig = signal<GlobalConfig>(DEFAULT_GLOBAL_CONFIG);
  readonly globalConfig = this._globalConfig.asReadonly();

  constructor() {
    this.applyTheme(this._globalConfig());

    effect(() => {
      this.applyTheme(this._globalConfig());
    });
  }


  isGlobalSettingEnabled<g extends keyof GlobalConfig['globalSettings']>(setting: g): boolean {
    return this._globalConfig().globalSettings[setting];
  }

  get globalTheme() {
    return this._globalConfig().globalTheme;
  }

  get globalSettings() {
    return this.globalConfig().globalSettings;
  }


  private applyTheme(config: GlobalConfig) {
    const root = document.documentElement;
    root.style.setProperty('--app-primary-color', config.globalTheme.primarySiteColor);
    root.style.setProperty('--app-secondary-color', config.globalTheme.secondarySiteColor);
    root.style.setProperty('--app-tertiary-color', config.globalTheme.tertiarySiteColor);
  }


  showErrorIfFieldBlank_String(f: any, fieldName: string, ms: MessageService): boolean {

    if (f == null || f == undefined || f == '') {
      ms.add({ severity: 'error', summary: 'Error saving', detail: `You must specify the ${fieldName} field`, sticky: false });
      return true;
    }
    return false;
  }
  showErrorIfFieldBlank_Number(f: any, fieldName: string, ms: MessageService): boolean {

    if (f == null || f == undefined || f == '' || isNaN(f)) {
      ms.add({ severity: 'error', summary: 'Error saving', detail: `You must specify the ${fieldName} field`, sticky: false });
      return true;
    }
    return false;
  }

}
